module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout Common */
(function(fox, $) {
	'use strict';
	fox.registerWidget('Layout_Common', {

		configure: function () {

			this.registerOptions('', {
				pageContainer: '.common-content',
				'templateOptions.domain': '',
				'hooks.onStopRendering': function () {
					var landingDesign = fox.cookie.get('landingDesign');
					if (landingDesign) {
						var wrapper = fox.dom.selectFirst('.promo-wrapper', this.fragment);
						fox.dom.addClass(landingDesign, wrapper);
					}
				},
				widgets: {
					header: {
						widget: 'Promo_Header',
						container: '.promo-header',
						template: 'promo2_header'
					},

					footer: {
						widget: 'Promo_Footer',
						template: 'promo2_footer',
						'handleDom.goTop':{
							target: '.gotop',
							event: 'click',
							callback: function() {
								window.scrollTo(0,0);
							}
						}
					},
				},

				'handleWom.markLink': {
					widget: '.Site_Page .Widget',
					event: 'addedToDom',
					callback: 'markLink',
					'params.prefix': 'markLink'
				}
			});

			this.callParent('configure', arguments);
		},

		init: function() {
			var parsed = fox.Navigator.parseSearch();
			
			if (parsed.landDesign) {
				fox.Consent.checkCookie('landingDesign').then(function() {
					fox.cookie.set('landingDesign', parsed.landDesign, 1000 * 3600 * 24 * 30);
				});
				fox.Consent.checkCookie('acode').then(function() {
					fox.cookie.set('acode', 'mnhhScH1');
				});
			}

			this.callParent('init', arguments);
		},
		
		running: function () {
			var scrollTimer = null;
			$(window).scroll(function () {
				if (scrollTimer) {
					clearTimeout(scrollTimer);
				}
				
				scrollTimer = setTimeout(function() {
					scrollTimer = null;
					var bodyScrollTop = Math.abs(document.body.getBoundingClientRect().top);
					if (bodyScrollTop > 59){  
						$('header').addClass("sticky");
						
					} else {
						$('header').removeClass("sticky");
					}
					//scroll to section 
					var curNav;
					var sections = fox.dom.select('#container section[id]');
					fox.each(sections, function(section){
						
						if(section.offsetTop <= bodyScrollTop + 150){
							curNav = $(section).attr('id');
							return curNav;
						}
					});

					if (fox.Navigator.get(0) !== curNav && typeof curNav !== 'undefined') {
						curNav = (curNav === 'home') ? '' : curNav;
						fox.Navigator.update({0: curNav}, true);
					}
				}, 300);
			});
			var landingDesign = fox.cookie.get('landingDesign');
			if (landingDesign) {
				$('.promo-wrapper').addClass(landingDesign);
			}
			this.callParent('running', arguments);
		},

		markLink: function (obj, w, e) {
			
			var page = fox.Navigator.get(0);
			var links = this.rwom1('#header').dom('.lnk');
			var attr = 'alias';

			if (page !== 'home') {
				window.scrollTo(0,0);
			}

			fox.each(links, function (link) {
				link = fox.dom.wrap(link);

				link.removeClass('active');
				if (link.attr(attr) === page) {
					link.addClass('active');
				}
			});
		}

	}, 'Site_Layout');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/common.js
// module id = 669
// module chunks = 2